module.exports = __webpack_public_path__ + "img/map-bg1.a52b60d6.svg";